"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

// Find all React elements of the specified type (or prop) and flat them
// Won't continue to search inside the target type element
var useElementChildren = function useElementChildren(_ref) {
  var children = _ref.children,
      type = _ref.type,
      prop = _ref.prop,
      hasCondition = _ref.hasCondition;
  return (0, _react.useMemo)(function () {
    if (hasCondition === false) return [];
    var childrenArray = [];

    var elementDirectChildren = _react["default"].Children.toArray(children);

    var findChildren = function findChildren(reactElement) {
      if (! /*#__PURE__*/_react["default"].isValidElement(reactElement)) return;
      var isType = type && reactElement.type === type;
      var isProp = prop && reactElement.props[prop] !== undefined;

      if (isType || isProp) {
        childrenArray.push(reactElement);
        return;
      }

      var nextLevelchildren = _react["default"].Children.toArray(reactElement.props.children);

      if (nextLevelchildren.length) {
        nextLevelchildren.forEach(function (child) {
          return findChildren(child);
        });
      }
    };

    elementDirectChildren.forEach(function (child) {
      return findChildren(child);
    });
    return childrenArray;
  }, [children, hasCondition, prop, type]);
};

var _default = useElementChildren;
exports["default"] = _default;
//# sourceMappingURL=useElementChildren.js.map